import React, { useEffect, useMemo, useState } from 'react';
import './BookingCard.css';
import { icabInstance } from '../config/Api';

const BookingCard = () => {
  const [enrolmentNo, setEnrolmentNo] = useState('');
  const [member, setMember] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [authorized, setAuthorized] = useState(
    () => sessionStorage.getItem('bookingCardAuth') === 'ok'
  );

  const pickValue = (...values) => values.find((value) => value !== undefined && value !== null && value !== '');

  const displayName = pickValue(
    member?.memberNameFul,
    member?.memberNameFull,
    member?.MemberName,
    member?.Name,
    member?.FullName,
    member?.fullName,
    member?.member_name
  );

  const displayEnrolment = pickValue(member?.enNo, member?.EnNo, member?.enrolmentNo);
  const [qrServiceIndex, setQrServiceIndex] = useState(0);

  const qrServices = useMemo(
    () => [
      'https://api.qrserver.com/v1/create-qr-code/',
      'https://quickchart.io/qr'
    ],
    []
  );

  const qrSrc = useMemo(() => {
    if (!displayEnrolment) return '';
    const encoded = encodeURIComponent(displayEnrolment);
    if (qrServiceIndex === 0) {
      return `${qrServices[0]}?size=220x220&data=${encoded}`;
    }
    return `${qrServices[1]}?size=220&text=${encoded}`;
  }, [displayEnrolment, qrServiceIndex, qrServices]);

  const handleLookup = async (event) => {
    event.preventDefault();
    if (!enrolmentNo.trim()) {
      setError('Please enter an enrolment number.');
      return;
    }
    setLoading(true);
    setError('');
    try {
      const { data } = await icabInstance.get('http://36.255.69.222:9002/api/v1/get-member-by-username', {
        params: { username: enrolmentNo.trim() }
      });
      if (data?.success === false) {
        setMember(null);
        setError(data?.message || 'No member data found for this enrolment number.');
        return;
      }
      const rawData =
        data?.payload ||
        data?.Payload ||
        data?.data ||
        data?.Data ||
        data?.member ||
        data;
      const memberData = Array.isArray(rawData) ? rawData[0] : rawData;
      setMember(memberData || null);
      if (!memberData) {
        setError('No member data found for this enrolment number.');
      }
    } catch (fetchError) {
      setError('Unable to fetch member data right now.');
    } finally {
      setLoading(false);
    }
  };

  const requestAccess = () => {
    const username = window.prompt('Username');
    const password = window.prompt('Password');
    if (username === 'print' && password === 'P^1973') {
      sessionStorage.setItem('bookingCardAuth', 'ok');
      setAuthorized(true);
      return;
    }
    setAuthorized(false);
  };

  useEffect(() => {
    if (!authorized) {
      requestAccess();
    }
  }, []);

  useEffect(() => {
    setQrServiceIndex(0);
  }, [displayEnrolment]);

  if (!authorized) {
    return (
      <div className="booking-card-locked">
        <div className="booking-card-locked-card">
          <h2>Access required</h2>
          <p>Enter username and password to view the card.</p>
          <button className="btn btn-primary" type="button" onClick={requestAccess}>
            Unlock
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="booking-card-page">
      <div className="booking-card-wrap">
        <div className="booking-card-title">ICAB Identity Card</div>
        <div className="booking-card-actions">
          <form className="booking-card-form" onSubmit={handleLookup}>
            <input
              className="booking-card-input"
              type="text"
              inputMode="numeric"
              placeholder="Enrolment No"
              value={enrolmentNo}
              onChange={(event) => setEnrolmentNo(event.target.value.replace(/[^0-9]/g, ''))}
            />
            <button
              className="btn btn-secondary booking-card-fetch"
              type="submit"
              disabled={loading}
            >
              {loading ? 'Loading...' : 'Fetch'}
            </button>
          </form>
          <button className="btn btn-primary booking-card-print" type="button" onClick={() => window.print()}>
            Print
          </button>
        </div>
        {error && <div className="booking-card-error">{error}</div>}
        <div className="booking-card-grid">
          <section className="print-page" aria-label="Printable front page">
            <div className="id-card id-card-front" aria-label="ICAB ID card front">
              {/* <div className="id-card-band"></div> */}
              <div className="id-card-body">
                <div className="id-card-name id-card-name-only">
                  <strong>
                    {displayName || 'Member Name'} {member?.acA_FCA || ''} ({member?.id || ''})
                  </strong>
                </div>
              </div>
              {/* <div className="id-card-footer">Institute of Chartered Accountants of Bangladesh</div> */}
            </div>
          </section>

          <section className="print-page" aria-label="Printable back page">
            <div className="id-card" aria-label="ICAB ID card back">
              {/* <div className="id-card-band"></div> */}
              <div className="id-card-body">
                <div className="id-card-back-header">
                </div>
                {displayEnrolment && (
                  <div className="id-card-qr id-card-qr-top">
                    <img
                      src={qrSrc}
                      alt={`QR ${displayEnrolment}`}
                      onError={() => {
                        setQrServiceIndex((prev) => (prev + 1) % qrServices.length);
                      }}
                    />
                  </div>
                )}
                <div className="id-card-back-grid gap-30">
                  <div>
                    <span className="id-card-date">17 January 2026</span>
                  </div>
                  {/* &nbsp; */}
                  <div>
                    Le Meridien, Dhaka.
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default BookingCard;
